'use client';
import PageLayout from "../PageLayout";
import { useParams } from 'next/navigation';
import { getSolutionById } from "./solutions/solutions";
import { useTranslation } from "react-i18next";
import { defaultLang, SUPPORTED } from "../../config/languages";
import { SOLUTION_SECTION } from "../../config/solutionSections";
import JsonLd from '@/components/JsonLd';
import { COMPANY_DATA } from '../../config/companyData';
import SingleSolutionLayout2 from './SingleLayout2';

export default function SingleSolution() {
  const { slug, lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const { t } = useTranslation(["solutions"]);
  const solution = getSolutionById(slug);
  if (!solution) return <PageLayout presentLikeHome title="Solution Not Found" metaDescription="The solution does not exist." noindex><main className="blog-v2-page"><h1>Solution Not Found</h1></main></PageLayout>;

  const tr = solution.translations?.[activeLang] || solution.translations?.en || solution;
  const imageUrl = solution.image?.startsWith("http") ? solution.image : `https://www.adcast.app${solution.image || ""}`;
  const slugFinal = typeof solution.slug === 'string' ? solution.slug : (solution.slug[activeLang] || solution.slug.en);
  const section = SOLUTION_SECTION[activeLang] || SOLUTION_SECTION.en;
  const url = `https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}/${slugFinal}`;
  const breadcrumb = {"@context":"https://schema.org","@type":"BreadcrumbList",itemListElement:[{"@type":"ListItem",position:1,name:t('solutions:title'),item:`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}`},{"@type":"ListItem",position:2,name:tr.title,item:url}]};
  const article = {"@context":"https://schema.org","@type":"Article",headline:tr.title,description:tr.description,image:imageUrl,datePublished:tr.datePublished || solution.datePublished,dateModified:tr.dateModified || solution.dateModified,author:{"@type":"Organization",name:COMPANY_DATA.name},publisher:{"@type":"Organization",name:COMPANY_DATA.name,logo:{"@type":"ImageObject",url:"https://www.adcast.app/adcast.svg"}},mainEntityOfPage:url,url};

  return <PageLayout presentLikeHome title={tr.title} metaDescription={tr.description} canonical={url} ogType="article" ogImage={imageUrl}>
    <JsonLd data={breadcrumb} id="breadcrumb-jsonld" />
    <JsonLd data={article} id="solutionposting-jsonld" />
    <SingleSolutionLayout2 solution={solution} title={tr.title} description={tr.description} content={tr.content} image={solution.image} url={url} slug={slugFinal} activeLang={activeLang} t={t} />
  </PageLayout>;
}
